import { RefObject, useEffect } from 'react';

type ArgConstraint = HTMLElement;

interface UseClickOutsideArgs {
  el: RefObject<ArgConstraint>;
  excludeEls?: RefObject<ArgConstraint>[];
  onClickOutside: () => unknown;
}

export const useClickOutside = ({ el, excludeEls = [], onClickOutside }: UseClickOutsideArgs) => {
  useEffect(() => {
    const handleClickOutside = (event: Event) => {
      if (
        !el.current ||
        el.current.contains(event.target as Node) ||
        excludeEls.find((e) => e.current && e.current.contains(event.target as Node))
      ) {
        return;
      }
      onClickOutside();
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
};
